<template>
  <BaseSection class="text-center">
    <div class="relative">
      <input
        :value="value"
        autofocus
        class="number-input text-center outline-none"
        type="tel"
        required="required"
        @input="$emit('input', $event.target.value)"
      >
      <span class="euro-sign absolute font-sans-medium text-2xl">€</span>
    </div>
    <div class="font-sans-medium leading-normal">{{ bottomText }}</div>
  </BaseSection>
</template>

<script>
import BaseSection from './BaseSection.vue';

export default {
  name: 'BaseBigNumberInput',
  components: {
    BaseSection,
  },
  props: {
    bottomText: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
  },
  watch: {
    value(newValue) {
      const result = newValue.replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      this.$nextTick(() => this.$emit('input', result));
    },
  },
};
</script>

<style lang="css" scoped>
.number-input {
  font-size: 54px;
  height: 74px;
  width: 260px;
}
.euro-sign {
  top: 9px;
}
</style>
